import { keepPreviousData } from '@tanstack/react-query'

import type { PaginationState } from '@gto/ui/data-table'

export const PAGE_SIZE_OPTIONS = [30, 50, 100]

export const INITIAL_PAGINATION: PaginationState = {
  pageSize: 30,
  pageIndex: 0,
}

/**
 * Shared by all three history tables: the same server-paged list read the same way, so the
 * cache policy lives once instead of drifting between them.
 */
export const HISTORY_QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  staleTime: 1000 * 60 * 5,
  gcTime: 1000 * 60 * 10,
  placeholderData: keepPreviousData,
} as const
